export function saleRemaining(end, now = Date.now()) {
  const expiresAt = Date.parse(end);
  const total = Number.isFinite(expiresAt) ? Math.max(0, Math.ceil((expiresAt - now) / 1000)) : 0;
  return {
    total,
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}

export function saleIsActive(end, now = Date.now()) {
  const expiresAt = Date.parse(end);
  return Number.isFinite(expiresAt) && now < expiresAt;
}

if (typeof document !== 'undefined' && !window.calvielleSaleReady) {
  window.calvielleSaleReady = true;
  const offers = new Set();
  const clocks = new Map();
  let timer;

  const updateClock = (element, refs, now) => {
    const remaining = saleRemaining(element.dataset.saleEnd, now);
    for (const unit of ['days', 'hours', 'minutes', 'seconds']) {
      if (!refs[unit]?.isConnected) refs[unit] = element.querySelector(`[data-sale-${unit}]`);
      const text = String(remaining[unit]).padStart(2, '0');
      if (refs[unit] && refs[unit].textContent !== text) refs[unit].textContent = text;
    }
  };

  const tick = () => {
    timer = undefined;
    const now = Date.now();
    for (const offer of offers) {
      if (!offer.isConnected) {
        offers.delete(offer);
        continue;
      }
      if (!saleIsActive(offer.dataset.saleEnd, now)) {
        offer.hidden = true;
        offers.delete(offer);
      }
    }
    for (const [element, refs] of clocks) {
      if (!element.isConnected || !saleIsActive(element.dataset.saleEnd, now)) {
        element.hidden = true;
        clocks.delete(element);
        continue;
      }
      updateClock(element, refs, now);
    }
    if (offers.size || clocks.size) timer = window.setTimeout(tick, 1010 - (Date.now() % 1000));
  };

  const register = (root) => {
    if (!(root instanceof Element) && root !== document) return;
    const nodes = root.querySelectorAll('[data-calvielle-sale], [data-sale-countdown]');
    const elements = root instanceof Element && root.matches('[data-calvielle-sale], [data-sale-countdown]')
      ? [root, ...nodes]
      : nodes;
    const now = Date.now();
    for (const element of elements) {
      if (!saleIsActive(element.dataset.saleEnd, now)) {
        element.hidden = true;
        continue;
      }
      if (element.hasAttribute('data-calvielle-sale')) offers.add(element);
      if (element.hasAttribute('data-sale-countdown') && !clocks.has(element)) {
        const refs = {};
        for (const unit of ['days', 'hours', 'minutes', 'seconds']) refs[unit] = element.querySelector(`[data-sale-${unit}]`);
        clocks.set(element, refs);
        updateClock(element, refs, now);
      }
    }
    if (timer === undefined && (offers.size || clocks.size)) tick();
  };

  register(document);
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) register(node);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      window.clearTimeout(timer);
      tick();
    }
  });
  window.addEventListener('pageshow', () => {
    window.clearTimeout(timer);
    timer = undefined;
    register(document);
    if (timer === undefined) tick();
  });
}
